var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54854 13.7744C7.66965 13.8955 7.83392 13.9635 8.00521 13.9635C8.17649 13.9635 8.34076 13.8955 8.46188 13.7744C8.583 13.6533 8.65104 13.489 8.65104 13.3177V3.69271C8.65104 3.52142 8.583 3.35715 8.46188 3.23604C8.34076 3.11492 8.17649 3.04688 8.00521 3.04688C7.83392 3.04688 7.66965 3.11492 7.54854 3.23604C7.42742 3.35715 7.35938 3.52142 7.35938 3.69271V13.3177C7.35938 13.489 7.42742 13.6533 7.54854 13.7744Z",
    fill: "#5A4AD5",
    stroke: "#5A4AD5",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19271 9.15104H12.8177C12.989 9.15104 13.1533 9.083 13.2744 8.96188C13.3955 8.84076 13.4635 8.67649 13.4635 8.50521C13.4635 8.33392 13.3955 8.16965 13.2744 8.04854C13.1533 7.92742 12.989 7.85938 12.8177 7.85938H3.19271C3.02142 7.85938 2.85715 7.92742 2.73604 8.04854C2.61492 8.16965 2.54688 8.33392 2.54688 8.50521C2.54688 8.67649 2.61492 8.84076 2.73604 8.96188C2.85715 9.083 3.02142 9.15104 3.19271 9.15104Z",
    fill: "#5A4AD5",
    stroke: "#5A4AD5",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0005b56a4dc31f0d4fe7825a8d18b855.svg";
export { ForwardRef as ReactComponent };